import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Card, CardHeader, CardBody, Row, Col, Button, Label, FormGroup } from 'reactstrap'
import { getUser, resetUserDetail } from '../../../../store/user/actions'
import { roles } from '../../../../common/constants'
import { MainLoader } from '../../../../components'

class UserDetail extends Component {

    componentDidMount() {
        this.props.getUser(this.props.match.params.id)
    }
    componentWillUnmount() {
        this.props.resetUserDetail();
    }

    renderField(label, value) {

        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="5">
                    <p className="form-control-static">{value}</p>
                </Col>
            </FormGroup>
        )
    }

    renderImageField(label, value) {
        return (
            <FormGroup row>
                <Col md='2' lg='1'>
                    <Label color='red'>{label}</Label>
                </Col>
                <Col xs="12" md="4">
                    {
                        value && <img src={value} style={{ maxHeight: 200 }} />
                    }
                </Col>
            </FormGroup>
        )
    }

    renderFields() {

        const user = this.props.user
        const storeName = user.store != null ? user.store.name : ''
        const documentType = user.document_type != null ? user.document_type.name : ''
        const roleId = user.role.id
        const roleName = user.role.name

        return (
            <div>
                {this.renderField('Nombre:', user.name)}
                {this.renderField('Tipo de documento:', documentType)}
                {this.renderField('N° de documento:', user.dni)}
                {this.renderField('Email:', user.email)}
                {this.renderField('Teléfono:', user.phone)}
                {this.renderField('Rol:', roleName)}
                {(roleId == roles.STORE_MANAGER || roleId == roles.CASHIER) && this.renderField('Tienda:', storeName)}
                {this.renderImageField('Foto:', user.photoUrl)}
            </div>
        )
    }

    render() {

        const { error, loading, user } = this.props

        if (error) {
            return (
                <Alert color="danger">
                    {error}
                </Alert>
            )
        }

        if (loading) {
            return <MainLoader />
        }
        else if (!user) return <div></div>

        return (
            <div className='animated'>
                <Card>
                    <CardHeader>
                        Detalle del Usuario
                    </CardHeader>
                    <CardBody>
                        {this.renderFields()}
                        <Row>
                            <Col className='mt-3'>
                                <Button color='secondary' onClick={() => this.props.history.push('/administration/users')} ><i className="fa fa-chevron-left mr-1" /> Volver</Button>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

function mapStateToProps(state) {

    const { user, error, loading } = state.user.activeUser

    return {
        user,
        error,
        loading,
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getUser,
        resetUserDetail
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetail)



// WEBPACK FOOTER //
// ./src/scenes/Administration/User/UserDetail/UserDetail.js